import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const MessageCard = props => {
  const {
    calloutText,
    bodyText,
    buttonText,
    floatingLinkText,
    imageName,
    messageCardClass,
    onFloatingButtonClick,
    onFloatingLinkClick,
    onFooterButtonClick,
    showTip,
    showSaveCTA,
    handleSave
  } = props;

  const classes = classnames('ndx-MessageCard', messageCardClass);

  const renderButton = (placement, onButtonClick) => {
    return (
      <div className={`ndx-MessageCard-${placement}ButtonWrapper`}>
        <div
          className={`ndx-MessageCard-button ndx-MessageCard-${placement}Button`}
          onClick={onButtonClick}>
          {buttonText}
        </div>
      </div>
    );
  };

  const renderTip = () => {
    return <div className="ndx-MessageCard-tip">INSIDER DESIGN TIP</div>;
  };

  const renderCalloutText = () => {
    return <h3 className="ndx-MessageCard-callout">{calloutText}</h3>;
  };

  const renderBodyText = () => {
    return (
      <div className="ndx-MessageCard-body">
        {bodyText}
        {onFloatingLinkClick && floatingLinkText && renderFloatingLink()}
      </div>
    );
  };

  const renderFloatingLink = () => {
    return (
      <div
        className="ndx-MessageCard-floatingLink"
        href="#"
        onClick={onFloatingLinkClick}>
        {floatingLinkText}
      </div>
    );
  };

  const styles = {
    backgroundImage: `url(${imageName})`
  };

  const renderSaveCTA = () => {
    return (
      <div className="ndx-MessageCard-saveCTA">
        <p>
          If you are looking for help with your design, be sure to save it so we
          can take a look.
        </p>
        <div className="ndx-cta-Secondary" onClick={handleSave}>
          Save Design
        </div>
      </div>
    );
  };

  return (
    <div className={classes}>
      <div className="ndx-MessageCard-content">
        <div className="ndx-MessageCard-image" style={styles} />
        {showTip && renderTip()}
        {calloutText && renderCalloutText()}
        {(bodyText || onFloatingLinkClick) && renderBodyText()}
        {onFloatingButtonClick &&
          renderButton('floating', onFloatingButtonClick)}
        {showSaveCTA && renderSaveCTA()}
      </div>
      {onFooterButtonClick && renderButton('footer', onFooterButtonClick)}
    </div>
  );
};

MessageCard.displayName = 'MessageCard';

const propTypes = {
  imageName: PropTypes.string.isRequired,
  bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.string,
  calloutText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  floatingLinkText: PropTypes.string,
  handleSave: PropTypes.func,
  messageCardClass: PropTypes.string,
  showSaveCTA: PropTypes.bool,
  showTip: PropTypes.bool,
  onFloatingButtonClick: PropTypes.func,
  onFloatingLinkClick: PropTypes.func,
  onFooterButtonClick: PropTypes.func
};

MessageCard.propTypes = propTypes;

MessageCard.defaultProps = {
  showTip: false
};

export default MessageCard;
